import {Button} from '@dropbox/dig-components/buttons';
import {Menu} from '@dropbox/dig-components/menu';
import {UIIcon} from '@dropbox/dig-icons';
import {CheckmarkLine} from '@dropbox/dig-icons/assets';
import type {ComponentProps} from 'react';

export const MetricYearSelector = ({
  year,
  years,
  onSelect,
  triggerClassName,
  triggerVariant = 'borderless',
  shouldPropagateClickOutsideMouseEvents = false,
}: {
  year: number;
  years: number[];
  onSelect: (year: number) => void;
  triggerClassName?: string;
  triggerVariant?: ComponentProps<typeof Button>['variant'];
  shouldPropagateClickOutsideMouseEvents?: boolean;
}) => (
  <Menu.Wrapper shouldPropagateClickOutsideMouseEvents={shouldPropagateClickOutsideMouseEvents}>
    {({getContentProps, getTriggerProps}) => (
      <>
        <Button
          {...getTriggerProps()}
          variant={triggerVariant}
          size="small"
          withDropdownIcon
          className={triggerClassName}
        >
          {String(year)}
        </Button>
        <Menu.Content {...getContentProps()} placement="bottom-end" minWidth="120px">
          <Menu.Segment>
            {years.map((candidate) => (
              <Menu.ActionItem
                key={candidate}
                onClick={() => onSelect(candidate)}
                withRightAccessory={candidate === year ? <UIIcon src={CheckmarkLine} /> : undefined}
              >
                {String(candidate)}
              </Menu.ActionItem>
            ))}
          </Menu.Segment>
        </Menu.Content>
      </>
    )}
  </Menu.Wrapper>
);
